import { Injectable } from '@angular/core';
import { Api } from '../../';


@Injectable()
export class Form 
{
  constructor(public api:Api) {

  }

  get(params?: any) {
    return this.api.get('index.php/survey/form', params);
  }

  getFields(params?: any) {
    return this.api.get('index.php/survey/form/fields', params);
  }

  getListResponse(params?: any) {
    return this.api.get('index.php/survey/form/dataResponse', params);
  }

  post(params?: any) {
    return this.api.post('index.php/survey/form', params);
  }

  // postResponse(params?:any){
  //   return this.api.post('index.php/survey/form', params);
  // }


}


// WEBPACK FOOTER //
// ./src/providers/survey/form/form.ts